import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { NoteState } from "../../context/notes/NoteState";
import ClientPortalServices from "../../UserServices/ClientPortalServices";
import logo from "../../icons/logo.png";
import "./ClientPortal.css";

export default function ClientChangePassword() {
  const { state, dispatch: ctxDispatch } = useContext(NoteState);
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirmation, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const logoutLocal = () => {
    ctxDispatch({ type: "LOGOUT" });
    navigate("/");
  };

  const submit = async (e) => {
    e.preventDefault();
    if (newPassword.length < 6) {
      toast.error("New password must be at least 6 characters");
      return;
    }
    if (newPassword !== newPasswordConfirmation) {
      toast.error("New passwords do not match");
      return;
    }
    setBusy(true);
    try {
      const res = await ClientPortalServices.changePassword({
        current_password: currentPassword,
        new_password: newPassword,
        new_password_confirmation: newPasswordConfirmation,
      });
      toast.success(res.data?.message || "Password updated. Please log in again.");
      logoutLocal();
    } catch (err) {
      const msg =
        err.response?.data?.message?.new_password?.[0] ||
        err.response?.data?.message ||
        "Could not change password";
      toast.error(typeof msg === "string" ? msg : "Could not change password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="cp-page">
      <div className="cp-card">
        <img src={logo} alt="Vostro World" className="cp-logo" />
        <h1>Change password</h1>
        <p className="cp-lead">
          {state.mustChangePassword
            ? "For security, you must set a new password before viewing your membership dashboard."
            : "Update your membership portal password."}
        </p>
        <form onSubmit={submit} className="cp-form">
          <label>
            Current password
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
              minLength={6}
              autoComplete="current-password"
            />
          </label>
          <label>
            New password
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={6}
              autoComplete="new-password"
            />
          </label>
          <label>
            Confirm new password
            <input
              type="password"
              value={newPasswordConfirmation}
              onChange={(e) => setConfirm(e.target.value)}
              required
              minLength={6}
              autoComplete="new-password"
            />
          </label>
          <button type="submit" className="cp-btn" disabled={busy}>
            {busy ? "Saving…" : "Save & sign out"}
          </button>
        </form>
      </div>
    </div>
  );
}
